module.exports = __webpack_public_path__ + "static/media/badgeOff_118.9b3aaab7.png";